/**
 * Created by nemio on 09.12.2015.
 */

import React, {Component, PropTypes} from 'react';

import {StubFunc} from '../../utils';

class BgSliderControls extends Component {

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return <div className="wrapper">
      <a className="bg_slides-arr slider-prev ico ico-arr-prev hover" onClick={this.props.onPrev}></a>
      <a className="bg_slides-arr slider-next ico ico-arr-next hover" onClick={this.props.onNext}></a>
    </div>
  }
}

BgSliderControls.propTypes = {
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired
};

BgSliderControls.defaultProps = {
  onPrev: StubFunc.bind(this, 'onPrev'),
  onNext: StubFunc.bind(this, 'onNext')
};

export default BgSliderControls;



// WEBPACK FOOTER //
// ./src/components/BgSlide/bg-slider-controls.js